import React, { useState } from "react";
import iconPassVissible from "../../../images/icons/visible_on_dark_grey32.png";
import iconPassHidden from "../../../images/icons/visible_off_dark_grey32.png";

export const PassInput = (props) => {
  const [typePass, setTypePass] = useState(true);
  return (
    <div className="login_form_container-input">
      <p className="login_form-name">{props.title}</p>
      <label className="pass_inpt_container">
        <input
          id="inpt_pass_id"
          value={props.value}
          onChange={(e) => props.setFunc(e.target.value)}
          className="pass_inpt_no_border"
          type={typePass ? "password" : "text"}
          placeholder="Пароль"
        />
        <img
          className="img_icon_visible_on"
          src={typePass ? iconPassVissible : iconPassHidden}
          alt=""
          onClick={() => setTypePass(!typePass)}
        />
      </label>
      <p className="login_inpt_message_error">{props.error}</p>
    </div>
  );
};
